module.exports = __webpack_public_path__ + "fonts/righthand-bolddash-personal.98f0f023.ttf";